export default require('../../src/front/Footer/Footer').default;
